import { NotificationStoreV1, NotificationDisplayServiceImplV1, } from './v1';
export * from './v1/types';
export function defineNotificationDisplayService() {
    return {
        id: 'notification-display-service',
        optionalDependencies: {
            featureServices: {
                's2:logger': '^1.0.0',
            },
        },
        create: ({ featureServices }) => {
            const logger = featureServices['s2:logger'] || console;
            const store = new NotificationStoreV1(logger);
            return {
                '1.1.0': (consumerId) => ({
                    featureService: new NotificationDisplayServiceImplV1(consumerId, store),
                }),
            };
        },
    };
}
//# sourceMappingURL=index.js.map